function fillWildcards(keyframes) {
  for (var i = 1; i < keyframes.length; i++) {
    var _keyframes$i;

    (_keyframes$i = keyframes[i]) !== null && _keyframes$i !== void 0 ? _keyframes$i : keyframes[i] = keyframes[i - 1];
  }
}

export { fillWildcards };